import { Component } from '@angular/core';
import { Marked } from '@ts-stack/markdown';
import { TopLevelRestPage } from 'src/app/shared/framework/top-level-rest-page';

@Component({
  selector: 'app-static',
  templateUrl: './static.page.html',
  styleUrls: ['./static.page.scss'],
})
export class StaticPage extends TopLevelRestPage<any> {
  public content: string = '';
  public onActivation(): void {
    this.content = Marked.parse(this.data.content);
  }

  override getTitle(): string | null {
    return this.data.title;
  }

  public onDeactivation(): void {}
}
